import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BucketListingModel, BucketModel } from "common/models/page-models/applicants/bucket/bucket-grid.model";
import { GridResolver } from "common/resolvers/core-resolvers/grid.resolver";
import { SystemService } from "common/services/core-services/system.service";
import { BucketWidgetService } from "common/widget/applicant-dashboard/bucket-widget.service";


@Injectable({
  providedIn: 'root',
})
export class BucketResolver extends GridResolver<
  BucketModel,
  BucketListingModel
> {
  constructor(
    protected fs: BucketWidgetService,
    protected override router: Router,
    protected override systemService: SystemService
  ) {
    super(fs, router, systemService);
  }
 


}
